// ui/floating/FloatingContainer.tsx
import styled from "styled-components";

export const FloatingContainer = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;

  width: 380px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;
